/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LocationStatus {
    Future = 0,
    Current = 1,
    OnHold = 2,
    Completed = 4,
}
